module.exports = __webpack_public_path__ + "static/img/tu5.6ba85ed1.png";